/**
 * 报表 reducer
 */
import { combineReducers } from 'redux'
import * as ACTIONS from '../actions/report_action'

function checkErrorReport(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_CHECKERRORREPORT:
            return action.checkErrorReport
        default:
            return state
    }
}
function checkStatisticsReport(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_CHECKSTATISTICSREPORT:
            return action.checkStatisticsReport
        default:
            return state
    }
}
function topNReport(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_TOPNREPORT:
            return action.topNReport
        default:
            return state
    }
}
function errorReportMonitorMap(state = {}, action) {
  switch (action.type) {
      case ACTIONS.SET_ERRORREPORTMONITORMAP:
          return action.errorReportMonitorMap
      default:
          return state
  }
}
function statisticsReportMonitorMap(state = {}, action) {
  switch (action.type) {
      case ACTIONS.SET_STATISTICSREPORTMONITORMAP:
          return action.statisticsReportMonitorMap
      default:
          return state
  }
}
function topNReportMonitorMap(state={}, action) {
  switch (action.type) {
      case ACTIONS.SET_TOPNREPORTMONITORMAP:
          return action.topNReportMonitorMap
      default:
          return state
  }
}
function checkErrorReportFiles(state = [], action) {
  switch (action.type) {
      case ACTIONS.SET_CHECKERRORREPORTFILES:
          return action.checkErrorReportFiles
      default:
          return state
  }
}
function checkStatisticsReportFiles(state = [], action) {
  switch (action.type) {
      case ACTIONS.SET_CHECKSTATISTICSREPORTFILES:
          return action.checkStatisticsReportFiles
      default:
          return state
  }
}

function topNReportFiles(state = [], action) {
  switch (action.type) {
      case ACTIONS.SET_TOPNREPORTFILES:
          return action.topNReportFiles
      default:
          return state
  }
}




const reportReducer = combineReducers({
    checkErrorReport,
    checkStatisticsReport,
    topNReport,
    errorReportMonitorMap,
    statisticsReportMonitorMap,
    topNReportMonitorMap,
    checkErrorReportFiles,
    checkStatisticsReportFiles,
    topNReportFiles
})

export default reportReducer
